export default "<div style=\"display: inline-block;\" #recaptcha></div>\n"